import React from 'react';
import { ManagementContentHeader } from './ManagementContentHeader';
import './Content.scss';
import { ManagementRoute } from '../../Routes/ManagementRoute';


export const ManagementContent: React.FC = () => {
    return (
        <div className='management-content-wrapper'>
            <ManagementContentHeader />
            <ManagementRoute />
        </div>
    );
};
